import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDeliveryDateCell } from "./fulfillment-group-csv-utils";

export const EstimatedDeliveryDateCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Delivery date", cell: (row) => formatDeliveryDateCell(row) };
